<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M9aZzw/tc-custom/9781250014825.jpg?1731214480228" alt="This image is the cover for the book Grandad, There's a Head on the Beach, Jimm Juree Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grandad, There's a Head on the Beach, Jimm Juree Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Grandad, There's a Head on the Beach</i> is the second Jimm Juree Mystery from award-winning author Colin Cotterill. </b><br/><br/>In rural Thailand, former crime reporter Jimm Juree must grapple with her quirky family, a mysterious mother and daughter on the lam and the small matter of a head on the beach ...<br/><br/>When Jimm Juree's mother sold the family house and invested in a rundown 'holiday camp' at the southern end of Thailand on the Gulf of Siam, the family had little choice but to follow. Jimm Juree, who was well on her way to achieving her goal of becoming the primary crime reporter for the major daily newspaper in Chiang Mai, is less than thrilled to have lost her job as a reporter and to be stuck in the middle of nowhere where little of interest happens. So it is with mixed feelings that she greets the news that a head has washed up on the beach. It's tragic, of course, but this could be the sort of sensational murder that would get her a byline in a major daily and keep her toehold on her journalism career. Now all she has to do is find out who was murdered, and why.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Cotterill
      </h2>
      
      <p class="authorDescription body article">Born in London, COLIN COTTERILL has worked as teacher in Israel, Australia, the U.S. and Japan before he started training teachers in Thailand. Cotterill and his wife live in a small fishing village on the Gulf of Siam in Southern Thailand. He has won the Dilys and a CWA Dagger and has been a finalist for several other awards. His Jimm Juree Mysteries include <I>Killed at the Whim of a Hat</I>; <I>Grandad, There's a Head on the Beach</I> and <I>The Axe Factor</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Minotaur Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ab840f8